import React, { useState, useEffect, useContext } from 'react';
import { Feature } from './SimilarFeatures';
import sfx from '../../../services/sounds';
import { VolumeContext } from '../../misc/volume-context';
import styled from 'styled-components';

const Tile: React.FC<{
    feature: Feature;
    onAnswer: (correct: boolean) => void;
    resetQuestion: boolean;
    isDisabled: boolean;
    bgColour: string;
}> = ({ feature, onAnswer, resetQuestion, isDisabled, bgColour = '#00C3A5' }) => {
    const [selected, setSelected] = useState(false);
    // const [tileFeature, setTileFeature] = useState(feature);
    const { volume } = useContext(VolumeContext);

    useEffect(() => {
        setSelected(false);
        // setTileFeature(feature);
    }, [feature]);

    useEffect(() => {
        console.log('Question reset');
        setSelected(false);
    }, [resetQuestion]);

    // let textClasses = classNames({
    //     'text-center': true,
    //     'text-success': selected && feature.correct,
    //     'text-danger': selected && !feature.correct,
    // });

    const handleSelected = () => {
        setSelected(true);
        onAnswer(feature.correct);
        if (feature.correct) {
            if (volume) sfx.correct.play();
        } else {
            if (volume) sfx.incorrect.play();
        }
    };

    return (
        <TileStyle
            bgColour={bgColour}
            correct={feature.correct}
            selected={selected}
            disabled={isDisabled}
            className={`grid-tile grid-tile--so ${feature.correct && selected ? 'grid-tile--correct' : ''} ${
                !feature.correct && selected ? 'grid-tile--false' : ''
            } `}
            onClick={selected || isDisabled ? undefined : handleSelected}
        >
            <div className="grid-tile__content">
                <div className="grid-tile__feature">
                    <img src={feature.image} className={'grid-tile__img--so'} width={'40px'} alt="" />
                    <h5 className={'text-center mb-0 grid-tile__text--so'}>{feature.text}</h5>
                </div>
            </div>
        </TileStyle>
    );
};

interface TileProps {
    bgColour: string;
    correct: boolean;
    selected: boolean;
    disabled: boolean;
}
const TileStyle = styled.button<TileProps>`
    background-color: ${(props) =>
        props.correct && props.selected ? props.bgColour + ' !important' : props.disabled ? '#CCCCCC' : ''};
    width: 100%;
    display: block;
    border: none;
    border-radius: 5px;
    border: solid 3px transparent;
    overflow: hidden;
    &:focus {
        outline: none;
        border-color: #0ab9f0;
    }
`;

export default Tile;
